import { isValidDomain } from "./js/utils/utils";

let instance = null;
export class IntegrationFunctions {
  constructor(params) {
    if (!instance) {
      instance = this;
      this.Parameters = params;
    }
    return instance;
  }

  setDomain(domain, isHttps){
    if(!isValidDomain(domain)){
      console.warn('Invalid domain input. Please provide a valid domain name.');
      return;
    }
    this.Parameters.sdkService.setDomain(domain, isHttps);
  }

  login (user, password){
    if(!user || !password){
      console.warn('Invalid user or password input. Please provide a valid user and password');
      return;
    }
    this.Parameters.sdkService.login(user, password);
  }
  getAgentInfo(){
    this.Parameters.sdkService.getAgentInfo();
  }
  logout() {
    this.Parameters.sdkService.logout();
  }

  retryFirstCall(){
    this.Parameters.sdkService.retryFirstCall();
  }

  changePassword(password, newPassword, confirmPassword) {
    this.Parameters.sdkService.changePassword(
      password,
      newPassword,
      confirmPassword
    );
  }
  changeVolumen(volSpeaker, volMicrophone) {
    this.Parameters.sdkService.changeVolumen(volSpeaker, volMicrophone);
  }
  mute() {
    this.Parameters.sdkService.mute();
  }
  stopStartRecording() {
    this.Parameters.sdkService.stopStartRecording();
  }
  holdCall() {
    this.Parameters.sdkService.holdCall();
  }
  digitDTMF(digit) {
    this.Parameters.sdkService.digitDTMF(digit);
  }
  getIVRList(){
    this.Parameters.sdkService.getIVRList();
  }
  startIVR(ivrID){
    this.Parameters.sdkService.startIVR(ivrID);
  }  
  hangUpAndLeaveMessage(){
    this.Parameters.sdkService.hangUpAndLeaveMessage();
  }
  getOutboundCampaigns() {
    let response;
    response = this.Parameters.sdkService.getOutboundCampaigns();
    return response;
  }
  getUnavailables() {
    let response;
    response = this.Parameters.sdkService.getUnavailables();
    return response;
  }
  setUnavailables(notReadyID) {
    this.Parameters.sdkService.setUnavailables(notReadyID);
  }
  setReady() {
    this.Parameters.sdkService.setReady();
  }
  setReadyWithPassword(agentPassword, adminPassword) {
    this.Parameters.sdkService.setReadyWithPassword(
      agentPassword,
      adminPassword
    );
  }
  getCallsToday(){
    this.Parameters.sdkService.getCallsToday();
  }
  getUnavailablesHistory() {
    this.Parameters.sdkService.getUnavailablesHistory();
  }
  hangUp() {
    this.Parameters.sdkService.hangUp();
  }
  makeManualCall(phone, camId, callKey, data1) {
    this.Parameters.sdkService.makeManualCall(phone, camId, callKey, data1);
  }
  hangUpManualCall(){
    this.Parameters.sdkService.hangUpManualCall();
  }
  updateDataCall(data, camId, callKey) {
    this.Parameters.sdkService.updateDataCall(data, camId, callKey);
  }
  cancelScheduledManualCall(){
    this.Parameters.sdkService.cancelScheduledManualCall();
  }
  getDispositions() {
    this.Parameters.sdkService.getDispositions();
  }
  getDispositionsAndNumbers() {
    this.Parameters.sdkService.getDispositionsAndNumbers();
  }
  saveDisposition(dispositionID, subdispositionID) {
    this.Parameters.sdkService.saveDisposition(dispositionID, subdispositionID);
  }
  exitDispositionMode() {
    this.Parameters.sdkService.exitDispositionMode();
  }
  exitAssistedMode() {
    this.Parameters.sdkService.exitAssistedMode();
  }
  getPhoneNumbers() {
    this.Parameters.sdkService.getPhoneNumbers();
  }
  reprogramOutbound(
    dispositionID,
    subdispositionID,
    dateCallback,
    telephone,
    existingNumber
  ) {
    this.Parameters.sdkService.reprogramOutbound(
      dispositionID,
      subdispositionID,
      dateCallback,
      telephone,
      existingNumber
    );
  }
  getCallbacks(campID) {
    this.Parameters.sdkService.getCallbacks(campID);
  }
  reprogramInbound(
    dispositionID,
    subdispositionID,
    dateCallback,
    telephone,
    existingNumber,
    callKey,
    data1,
    data2,
    data3,
    data4,
    data5
  ) {
    this.Parameters.sdkService.reprogramInbound(
      dispositionID,
      subdispositionID,
      dateCallback,
      telephone,
      existingNumber,
      callKey,
      data1,
      data2,
      data3,
      data4,
      data5
    );
  }
  getXferOptions() {
    this.Parameters.sdkService.getXferOptions();
  }
  blindTransferCallToAgent(ext, callKey) {
    this.Parameters.sdkService.blindTransferCallToAgent(ext, callKey);
  }
  blindTransferCallToInboundCamp(inCamp,callKey) {
    this.Parameters.sdkService.blindTransferCallToInboundCamp(inCamp, callKey);
  }
  blindTransferCallToDirectory(dirNumber, callKey) {
    this.Parameters.sdkService.blindTransferCallToDirectory(dirNumber, callKey);
  }
  blindTransferCallToManualNumber(manualNumber, callKey) {
    this.Parameters.sdkService.blindTransferCallToManualNumber(manualNumber, callKey);
  }

  assistedTransferCallToAgent(ext) {
    this.Parameters.sdkService.assistedTransferCallToAgent(ext);
  }
  assistedTransferCallToInboundCamp(inCamp) {
    this.Parameters.sdkService.assistedTransferCallToInboundCamp(inCamp);
  }
  assistedTransferCallToDirectory(dirNumber) {
    this.Parameters.sdkService.assistedTransferCallToDirectory(dirNumber);
  }
  assistedTransferCallToManualNumber(manualNumber) {
    this.Parameters.sdkService.assistedTransferCallToManualNumber(manualNumber);
  }
  assistedTransferSwitchPrimaryCall() {
    this.Parameters.sdkService.assistedTransferSwitchPrimaryCall();
  }
  assistedTransferSwitchSecondaryCall() {
    this.Parameters.sdkService.assistedTransferSwitchSecondaryCall();
  }

  assistedTransferCreateConference() {
    this.Parameters.sdkService.assistedTransferCreateConference();
  }

  assistedTransferCallToSecondCall() {
    this.Parameters.sdkService.assistedTransferCallToSecondCall();
  }

  assistedTransferLeaveConference() {
    this.Parameters.sdkService.assistedTransferLeaveConference();
  }

  assistedTransferHangupCall(){
    this.Parameters.sdkService.assistedTransferHangupCall();
  };

  assistedTransferHangupSecondCall(){
    this.Parameters.sdkService.assistedTransferHangupSecondCall();
  };

  setAudioPath(pathAudio, secondsPlay) {
    this.Parameters.sdkService.setAudioPath(pathAudio, secondsPlay);
  }

  getAdminsToChat(){
    this.Parameters.sdkService.getAdminsToChat();
  }

  sendChatToAdmin(message, adminName){
    this.Parameters.sdkService.sendChatToAdmin(message, adminName);
  }
  getChats(){
    this.Parameters.sdkService.getChats();
  }
  getLastCallDataInbound(){
    this.Parameters.sdkService.getLastCallDataInbound();
  }
  getLastCallDataOutbound(){
    this.Parameters.sdkService.getLastCallDataOutbound();
  }
  toolsTransfersOptions(){
    this.Parameters.sdkService.toolsTransfersOptions();
  }

}
